import React, { useState } from "react";
import { toast } from "react-toastify";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import * as api from "../redux/api";
import { isYupError, parseYupError } from "../utils/Yup";
import { updateAdminPasswordValidation } from "../utils/validation";
import { useNavigate } from "react-router-dom";
const initialState = {
  email: "",
  oldPassword: "",
  newPassword: ""
};
const Setting = () => {
  const navigate = useNavigate();
  const [eye, setEye] = useState(false);
  const [eyeNew, setEyeNew] = useState(false);
  const [form, setForm] = useState(initialState);
  const [formError, setFormError] = useState(initialState);
  const [setIsLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value
    });
    setFormError({
      ...formError,
      [name]: ""
    });
  };

  const handleChangeEmail = async () => {
    const payload = {
      email: form.email
    };
    const res = await api.changeEmail(payload);
    const { status, data } = res;
    if (status) {
      setForm({ email: "", oldPassword: "", newPassword: "" });
      toast.success("Email Update Successfully");
    } else {
      toast.error(data.message);
    }
  };

  const handleChangePassword = async () => {
    // setIsLoading(true);
    try {
      setFormError({});
      await updateAdminPasswordValidation.validate(form, {
        abortEarly: false
      });
      const payload = {
        oldPassword: form.oldPassword,
        newPassword: form.newPassword
      };
      const res = await api.changePassword(payload);
      console.log(res, "response");
      if (res.status === 200 || res.status === 201) {
        setIsLoading(false);
        toast.success("Password Update Successfully");
        navigate("/dashboard");
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      if (isYupError(error)) {
        setFormError(parseYupError(error));
        setIsLoading(false);
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        console.log(error, "error");
        toast.error(error.message);
        setIsLoading(false);
      }

      setIsLoading(false);
    }
  };
  return (
    <div>
      <form className="max-w-4xl ">
        <header>
          <h4 className="text-white">Settings</h4>
        </header>
        <div className="w-full grid grid-cols-1 gap-6 mt-4">
          <div className="flex items-center gap-3">
            <div className="input_field">
              <input
                type="text"
                placeholder="Email Address"
                name="email"
                onChange={handleChange}
              />
            </div>
            <div className="">
              <button
                type="button"
                className="bg-white p-3 rounded-lg px-6 font-semibold border border-[#00D97A]"
                onClick={handleChangeEmail}
              >
                {" "}
                Update
              </button>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div>
              <div className="input_field relative min-w-[200px]">
                <input
                  type={eye ? "text" : "password"}
                  placeholder="Old Password"
                  name="oldPassword"
                  onChange={handleChange}
                />

                <button
                  type="button"
                  className="absolute right-4 top-[50%] translate-y-[-50%] cursor-pointer z-10"
                  onClick={() => setEye(!eye)}
                >
                  {eye ? (
                    <AiFillEye className="text-2xl text-theme-text" />
                  ) : (
                    <AiFillEyeInvisible className="text-2xl text-theme-text" />
                  )}
                </button>
              </div>
              {formError.oldPassword && (
                <div className="form-eror">{formError.oldPassword}</div>
              )}
            </div>
            <div>
              <div className="input_field relative min-w-[200px]">
                <input
                  type={eyeNew ? "text" : "password"}
                  placeholder="New Password"
                  name="newPassword"
                  onChange={handleChange}
                />

                <button
                  type="button"
                  className="absolute right-4 top-[50%] translate-y-[-50%] cursor-pointer z-10"
                  onClick={() => setEyeNew(!eyeNew)}
                >
                  {eyeNew ? (
                    <AiFillEye className="text-2xl text-theme-text" />
                  ) : (
                    <AiFillEyeInvisible className="text-2xl text-theme-text" />
                  )}
                </button>
              </div>
              {formError.newPassword && (
                <div className="form-eror">{formError.newPassword}</div>
              )}
            </div>
            <div className="">
              <button
                type="button"
                className="bg-white p-3 rounded-lg px-6 font-semibold border border-[#00D97A]"
                onClick={handleChangePassword}
              >
                {" "}
                Update
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Setting;
